// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_animated-gradient-text__seEhL {
  background-image: linear-gradient(90deg, #6ba5ff, #4682b4, #aa336a, #c41e3a);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 48px;
  font-weight: 600;
  animation: styles_gradientText__5TwIN 6s ease infinite;
  display: inline-block; }

@keyframes styles_gradientText__5TwIN {
  0% {
    background-position: 0% 50%; }
  50% {
    background-position: 100% 50%; }
  100% {
    background-position: 0% 50%; } }

.styles_container__gsOIO {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 1s all;
  overflow: hidden;
  border-image: linear-gradient(180deg, #ff6b6b, #6ba5ff, #8b1a34) 1;
  border-image: linear-gradient(180deg, #990000, #6ba5ff, #8b1a34) 1;
  animation: styles_borderMove__TWjXM 3s ease infinite;
  border-right: 3px solid; }
  .styles_container__gsOIO.styles_open__Gr\\+xu {
    width: 75%; }
    .styles_container__gsOIO.styles_open__Gr\\+xu .styles_toggleContainer__bKX8w {
      right: 5%; }
  .styles_container__gsOIO.styles_closed__sSKE8 {
    width: 10%; }
    .styles_container__gsOIO.styles_closed__sSKE8 .styles_linkContainer__gNstp {
      display: none; }
    .styles_container__gsOIO.styles_closed__sSKE8 .styles_header__V6CAR h2 {
      display: none; }
    .styles_container__gsOIO.styles_closed__sSKE8 .styles_toggleContainer__bKX8w {
      right: 50%;
      transform: rotate(180deg); }
  .styles_container__gsOIO .styles_header__V6CAR {
    min-height: 10rem;
    /* allow up to two lines (line-height: 5rem) */
    width: 100%;
    margin-bottom: 1rem; }
    .styles_container__gsOIO .styles_header__V6CAR p {
      height: 100%; }
    .styles_container__gsOIO .styles_header__V6CAR h2 {
      font-size: 3rem;
      line-height: 5rem;
      font-weight: 900;
      margin-left: 15%;
      margin-top: 1rem;
      margin-bottom: unset;
      /* two-line clamp with ellipsis */
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: calc(2 * 5rem);
      word-break: break-word; }
      .styles_container__gsOIO .styles_header__V6CAR h2:hover {
        background-image: linear-gradient(90deg, #6ba5ff, #4682b4, #aa336a, #c41e3a);
        background-size: 180% 100%;
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        animation: styles_gradientText__5TwIN 6s ease infinite;
        display: inline-block; }
  .styles_container__gsOIO .styles_links__jn6Kf {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: -webkit-fill-available;
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 3rem; }
    .styles_container__gsOIO .styles_links__jn6Kf > div {
      width: 90%;
      display: flex;
      flex-direction: column;
      align-items: center; }
  .styles_container__gsOIO .styles_active__3lSia p.styles_link__dVjzY,
  .styles_container__gsOIO .styles_active__3lSia h2 {
    background-image: linear-gradient(90deg, #6ba5ff, #4682b4, #aa336a, #c41e3a);
    background-size: 180% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    animation: styles_gradientText__5TwIN 6s ease infinite;
    display: inline-block; }

@keyframes styles_borderMove__TWjXM {
  0% {
    border-image: linear-gradient(180deg, #ff6b6b, #6ba5ff, #8b1a34) 1; }
  50% {
    border-image: linear-gradient(180deg, #990000, #6ba5ff, #8b1a34) 1; }
  100% {
    border-image: linear-gradient(180deg, #ff6b6b, #6ba5ff, #8b1a34) 1; } }

.styles_toggleContainer__bKX8w {
  position: absolute;
  top: 3rem;
  height: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: 1s all; }

.styles_container__gsOIO {
  height: 100vh; }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/BoothScreen/Sidemenu/styles.module.scss","webpack://./src/modules/admin/components/AdminSidemenu/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,4EAA4E;EAC5E,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sDAAwC;EACxC,qBAAqB,EAAA;;AAGvB;EACE;IACE,2BAA2B,EAAA;EAE7B;IACE,6BAA6B,EAAA;EAE/B;IACE,2BAA2B,EAAA,EAAA;;AClB/B;EDuBE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EA8FhB,kEAAkE;EAClE,kEAAkE;EAClE,oDAAsC;EACtC,uBAAuB,EAAA;EC7HzB;ID8BI,UAAU,EAAA;IC9Bd;MDgCM,SAAS,EAAA;EChCf;IDoCI,UAAU,EAAA;ICpCd;MDsCM,aAAa,EAAA;ICtCnB;MDyCM,aAAa,EAAA;ICzCnB;MD4CM,UAAU;MACV,yBAAyB,EAAA;EC7C/B;IDiDI,iBAAiB;IAAE,8CAAA;IACnB,WAAW;IACX,mBAAmB,EAAA;ICnDvB;MDqDM,YAAY,EAAA;ICrDlB;MDuEM,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB;MAChB,oBAAoB;MACpB,iCAAA;MACA,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;MAC5B,gBAAgB;MAChB,uBAAuB;MACvB,0BAA0B;MAC1B,sBAAsB,EAAA;MCpF5B;QDyDQ,4EAMC;QACD,0BAA0B;QAC1B,6BAA6B;QAC7B,qBAAqB;QACrB,kBAAkB;QAClB,sDAAwC;QACxC,qBAAqB,EAAA;ECrE7B;IDwFI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAOhB,mBAAmB,EAAA;ICrGvB;MDgGM,UAAU;MACV,aAAa;MACb,sBAAsB;MACtB,mBAAmB,EAAA;ECnGzB;;ID0GM,4EAMC;IACD,0BAA0B;IAC1B,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,sDAAwC;IACxC,qBAAqB,EAAA;;AAU3B;EACE;IACE,kEAAkE,EAAA;EAEpE;IACE,kEAAkE,EAAA;EAEpE;IACE,kEAAkE,EAAA,EAAA;;AAItE;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB,EAAA;;ACpJpB;EAEI,aAAa,EAAA","sourcesContent":[".animated-gradient-text {\n  background-image: linear-gradient(90deg, #6ba5ff, #4682b4, #aa336a, #c41e3a);\n  background-size: 300% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  font-size: 48px;\n  font-weight: 600;\n  animation: gradientText 6s ease infinite;\n  display: inline-block;\n}\n\n@keyframes gradientText {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.container {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: 1s all;\n  overflow: hidden;\n  &.open {\n    width: 75%;\n    .toggleContainer {\n      right: 5%;\n    }\n  }\n  &.closed {\n    width: 10%;\n    .linkContainer {\n      display: none;\n    }\n    .header h2 {\n      display: none;\n    }\n    .toggleContainer {\n      right: 50%;\n      transform: rotate(180deg);\n    }\n  }\n  & .header {\n    min-height: 10rem; /* allow up to two lines (line-height: 5rem) */\n    width: 100%;\n    margin-bottom: 1rem;\n    p {\n      height: 100%;\n    }\n    h2 {\n      &:hover {\n        background-image: linear-gradient(\n          90deg,\n          #6ba5ff,\n          #4682b4,\n          #aa336a,\n          #c41e3a\n        );\n        background-size: 180% 100%;\n        -webkit-background-clip: text;\n        background-clip: text;\n        color: transparent;\n        animation: gradientText 6s ease infinite;\n        display: inline-block;\n      }\n      font-size: 3rem;\n      line-height: 5rem;\n      font-weight: 900;\n      margin-left: 15%;\n      margin-top: 1rem;\n      margin-bottom: unset;\n      /* two-line clamp with ellipsis */\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-height: calc(2 * 5rem);\n      word-break: break-word;\n    }\n  }\n  & .links {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    height: -webkit-fill-available;\n    width: 100%;\n    margin-top: 1rem;\n    & > div {\n      width: 90%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n    margin-bottom: 3rem;\n  }\n  & .active {\n    p.link,\n    h2 {\n      background-image: linear-gradient(\n        90deg,\n        #6ba5ff,\n        #4682b4,\n        #aa336a,\n        #c41e3a\n      );\n      background-size: 180% 100%;\n      -webkit-background-clip: text;\n      background-clip: text;\n      color: transparent;\n      animation: gradientText 6s ease infinite;\n      display: inline-block;\n    }\n  }\n\n  border-image: linear-gradient(180deg, #ff6b6b, #6ba5ff, #8b1a34) 1;\n  border-image: linear-gradient(180deg, #990000, #6ba5ff, #8b1a34) 1;\n  animation: borderMove 3s ease infinite;\n  border-right: 3px solid;\n}\n\n@keyframes borderMove {\n  0% {\n    border-image: linear-gradient(180deg, #ff6b6b, #6ba5ff, #8b1a34) 1;\n  }\n  50% {\n    border-image: linear-gradient(180deg, #990000, #6ba5ff, #8b1a34) 1;\n  }\n  100% {\n    border-image: linear-gradient(180deg, #ff6b6b, #6ba5ff, #8b1a34) 1;\n  }\n}\n\n.toggleContainer {\n  position: absolute;\n  top: 3rem;\n  height: 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: 1s all;\n}\n","@import 'modules/shelter/components/BoothScreen/Sidemenu/styles.module.scss';\n\n.container {\n    @extend .container;\n    height: 100vh;\n}\n\n.header {\n    @extend .header;\n}\n\n.active {\n    @extend .active;\n}\n\n.links {\n    @extend .links;\n}\n\n.linkContainer {\n    @extend .linkContainer;\n}\n\n.closed {\n    @extend .closed;\n}\n\n.open {\n    @extend .open;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"animated-gradient-text": `styles_animated-gradient-text__seEhL`,
	"gradientText": `styles_gradientText__5TwIN`,
	"container": `styles_container__gsOIO`,
	"borderMove": `styles_borderMove__TWjXM`,
	"open": `styles_open__Gr+xu`,
	"toggleContainer": `styles_toggleContainer__bKX8w`,
	"closed": `styles_closed__sSKE8`,
	"linkContainer": `styles_linkContainer__gNstp`,
	"header": `styles_header__V6CAR`,
	"links": `styles_links__jn6Kf`,
	"active": `styles_active__3lSia`,
	"link": `styles_link__dVjzY`
};
export default ___CSS_LOADER_EXPORT___;
